import { Injectable } from '@angular/core';

import { SessionTokenService } from './session-token.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private readonly sessionTokenService: SessionTokenService) {}

  checkHavePermissions(permission: string | string[]): boolean {
    const permissions = this.sessionTokenService.getPermissions();
    
    if (Array.isArray(permission)) {
      return permission.some((per) => permissions.includes(per));
    }

    return permissions.includes(permission);
  }
}
